<div class="preloader">
  <div class="container">
    <div class="big-404">404</div>
    <div>Whoops! Page Not Found!</div>
  </div>
</div>

